module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SignListView.js"));
	}, "SignListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SignListView!./src/pages/Promote/OfflineActivity/EnterActivity/SignList/SignListView.js
// module id = 1180
// module chunks = 431